import { render } from "./viewOrderDetails.vue?vue&type=template&id=f40bf3fa&scoped=true"
import script from "./viewOrderDetails.vue?vue&type=script&lang=js"
export * from "./viewOrderDetails.vue?vue&type=script&lang=js"

import "./viewOrderDetails.vue?vue&type=style&index=0&id=f40bf3fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40bf3fa"]])

export default __exports__